import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Card from '../Card';
import CardContent from '../CardContent';
import ModalTitle from '../ModalTitle';
import styles from './ModalHighlight.module.css';
const ModalHighlight = ({ title, content, imageUrl }) => {
    return (_jsxs(Card, Object.assign({ className: styles.root }, { children: [imageUrl && (_jsx("div", { style: {
                    backgroundImage: `url(${imageUrl})`,
                    height: '100%',
                    width: '50%',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                } }, void 0)), _jsxs("div", Object.assign({ className: styles.textContentWrapper }, { children: [title && _jsx(ModalTitle, Object.assign({ className: styles.title }, { children: title }), void 0), content && (_jsx(CardContent, Object.assign({ className: styles.contentWrapper }, { children: content }), void 0))] }), void 0)] }), void 0));
};
export default ModalHighlight;
